import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import sdk from '../../../sdk';
import Tag from '../../Tag';
import Logger from '../../../services/Logger';
import { getStatusFromResponceError } from '../../../shared/utils';
import ua from '../../../ua';

const FacesChips = (props) => {
  const { faces = [], handleOnClick = null } = props;
  const allFaces = useSelector((state) => state.faces.all);
  const [currentFaces, setCurrentFaces] = useState([]);

  useEffect(() => {
    if (!allFaces || !faces) return;

    let cancelled = false;

    const processCurrentFaces = async () => {
      const result = await Promise.all(
        allFaces
          .filter((face) => faces.some((f) => f._id === face._id))
          .map(async (face) => {
            let url = face.avatar;

            if (!url && face.isAvatarUrlReady) {
              let avatar = `/faces/${face._id}/avatar`;

              if (ua.isMobileApp()) {
                try {
                  const response = await sdk.faces.getAvatarUrl(face._id);
                  avatar = response.data.url;
                } catch (err) {
                  const errorStatus = getStatusFromResponceError(err);
                  if (errorStatus !== 409) {
                    Logger.error(new Error('Failed to load avatar for current face'), { error: err }, [
                      'LoadCurrentFaceAvatarFailed',
                      { errorMessage: (err && err.message) || 'NoMessage' },
                    ]);
                  }
                  avatar = null;
                }
              }

              url = avatar;
            }

            return {
              ...face,
              title: face.name,
              url,
            };
          }),
      );

      if (!cancelled) {
        setCurrentFaces(result);
      }
    };

    processCurrentFaces();

    // eslint-disable-next-line consistent-return
    return () => {
      cancelled = true;
    };
  }, [allFaces, faces]);

  return (
    <div className="InfoPanel__Row">
      {currentFaces.map((face) => (
        <Tag
          onClick={(e) => handleOnClick(face._id)}
          type="user"
          key={face._id}
          avatar={face.url}
          text={face.name}
        />
      ))}
    </div>
  );
};

FacesChips.propTypes = {
  faces: PropTypes.arrayOf(PropTypes.any),
  handleOnClick: PropTypes.func,
};

export default FacesChips;
